import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import * as screenfull from 'screenfull';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router,NavigationExtras } from '@angular/router';
import { Pagearray} from '../../../pagesarray';
import {TabService} from '../tabsmenu/tabservice';
import { Tab } from "../tabsmenu/tabmodel";
import { AuthService } from 'app/auth-guard/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
 
  @Input() showToggle = true;
  @Input() showBranding = false;
  @Input() showHeader = true;
  
  @Input() showlogo ='dark';
  @Output() toggleSidenav = new EventEmitter<void>();
  @Output() toggleSidenavNotice = new EventEmitter<void>();
  @Input() toggleChecked = false;
  @Input() menupos ='side';

  @Output() toggleCollapsed = new EventEmitter<void>();
  @Output() showsetting1 = new EventEmitter<object>();
  private get screenfull(): screenfull.Screenfull {
    return screenfull as screenfull.Screenfull;
  }
  setplaceholder:any;
  cust_search:FormGroup;
  show_search:boolean=true;
  navurl:any
  ispoolcust = false;
  constructor(private fb: FormBuilder,private router:Router,public tabService:TabService,private authservice:AuthService) {
    this.setplaceholder="Enter Chassis Id";
    this.cust_search=this.fb.group({
      search_cat:'',
      searchvalue:['', [Validators.required]],

    });
    this.ispoolcust = (this.authservice.getstoragedtl().user_role=='PC')?true:false;
    this.cust_search.get('search_cat').setValue('Equipment Search');
    this.navurl='Equipment Search';

  }

  ngOnInit() {}

  // TODO:
  toggleFullscreen()
  {
    if (this.screenfull.enabled) {
      this.screenfull.toggle();
    }
  }

 

 
  toggles(){
    setTimeout(() => {
     window.dispatchEvent(
       new Event('resize')
     );
    }, 300);
  }

  resize(){
    setTimeout(() => {
      window.dispatchEvent(
        new Event('resize')
      );
     }, 300);
  }

  getshowsetting(val){
    
    this.showsetting1.emit(val);
  }

}
